<template>
    <div class="cur-avatar">
        <el-upload
                class="avatar-uploader"
                :show-file-list="false"
                :action="actionUrl"
                :headers="{'Content-Type': 'multipart/form-data; boundary=9431149156168'}"
                :accept="uploadAccept"
                :before-upload="handleBeforeUpload"
                :on-success="handleSuccess"
                :on-error="handleError"
                :http-request="handleRequest">
            <img v-if="currentAvatar" :src="currentAvatar" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div class="upload-avatar-mask">换一张</div>
        </el-upload>
        <span class="upload-introduce">只支持JPG、PNG，大小不超过100K
            <span v-show="loading" class="upload-loading">上传中...</span></span>
    </div>
</template>
<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import UUID from 'uuid';
export default {
    props: {
        imgUrl: {
            type: String,
            defalut: ''
        }
    },
    data() {
        return {
            flag: true,
            loading: false,
            form: {},
            currentAvatar: this.imgUrl
        };
    },
    computed: {
        ...mapState({
            imgConfig: state => state.user.imgConfig
        }),
        actionUrl() {
            let imgConfig = this.imgConfig;
            return `http://${imgConfig.host}`;
        },
        uploadAccept() {
            let accept = 'image/png, image/jpg';
            return accept;
        }
    },
    beforeMount() {
        this.USER_GET_IMG_CONFIG();
    },
    watch: {
        imgUrl(newLocale) {
            this.currentAvatar = newLocale;
        }
    },
    methods: {
        ...mapActions(['USER_GET_IMG_CONFIG']),
        handleRequest() {
            // http://yunxiao-test.kss.ksyun.com
            let imgConfig = this.imgConfig;
            let form = this.form;
            let formData = new FormData();
            formData.append('key', form.keyPrefix + '/' + form.key);
            formData.append('KSSAccessKeyId', form.KSSAccessKeyId);
            formData.append('policy', form.policy);
            formData.append('signature', form.signature);
            formData.append('file', form.file);
            this.loading = true;
            let hostAddress = imgConfig.host.indexOf('http') > -1 ? imgConfig.host : `http://${imgConfig.host}`;
            return Vue.axios({
                timeout: 0,
                headers: {
                    'Content-Type': 'multipart/form-data; boundary=9431149156168'
                }
            })
                .post(hostAddress, formData)
                .then(() => {
                    let url = '/' + imgConfig.bucket + '/' + form.keyPrefix + '/' + form.key;
                    return this.getImgUrl(url).then(result => {
                        return {
                            uid: form.file.uid,
                            name: form.name,
                            size: form.file.size,
                            url: result.urls[0] || ''
                        };
                    });
                });
        },
        getImgUrl(url) {
            return Vue.axios({ baseURL: `${feConfig.api.base}`, withCredentials: true })
                .post('/v1/config/ks3/authorization/urls', {
                    keys: [url]
                })
                .then(resp => Vue.checkResp(resp));
        },
        handleBeforeUpload(file) {
            const isLt5M = file.size / 1024 < 100;
            let fileNameReg = /^[\u4e00-\u9fa5 a-z A-Z 0-9 \- _ () .]+$/g;
            let name = file.name;
            if (!fileNameReg.test(name)) {
                this.$message.warning('上传文件的文件名中不能包含特殊字符');
                return false;
            }
            if (!isLt5M) {
                this.$message.warning('文件' + file.name + '大小不能超过100K!');
                return false;
            }
            let imgConfig = this.imgConfig;
            let lastIdx = file.name.lastIndexOf('.');
            let keyName = '';
            if (lastIdx > 0) {
                let fileSuffix = file.name.substring(lastIdx);
                let reg = /[\u4e00-\u9fa5]/g;
                if (!reg.test(fileSuffix)) {
                    keyName = fileSuffix;
                }
            }
            this.form = {
                name,
                key: `${feConfig.imgService.prefix}` + UUID.v4() + keyName,
                KSSAccessKeyId: imgConfig.ak,
                policy: imgConfig.policy,
                signature: imgConfig.signature,
                keyPrefix: imgConfig.keyPrefix,
                file: file
            };
        },
        handleSuccess(res) {
            this.$emit('change', res.url);
            this.loading = false;
        },
        handleError() {
            this.$message.error('头像' + this.form.name + '上传失败');
            this.loading = false;
        }
    }
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
    .cur-avatar {
        position: relative;
    }

    .upload-avatar-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100px;
        height: 100px;
        border-radius: 50px;
        background-color: rgba(0, 0, 0, 0.5);
        color: #fff;
        text-align: center;
        line-height: 100px;
        display: none;
    }

    .el-upload:hover .upload-avatar-mask {
        display: block;
    }

    .avatar-uploader .el-upload {
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 100px;
        height: 100px;
        display: block;
    }

    .upload-loading {
        display: inline-block;
        margin-left: 10px;
        color: #1daef6;
    }

    .upload-introduce {
        position: absolute;
        top: 44px;
        left: 120px;
        width: 500px;
        font-size: 12px;
        color: #b1b1b1;
        line-height: 1;
    }
</style>



// WEBPACK FOOTER //
// src/views/index/components/AppUploadAvatar.vue